declare var window: any;

export class DynamicEnvironment {
    public getEnvironment() {
        return window.config.environment;
    }
public getSpringBootApiUrl(){
    return window.config.spring_boot_url;

}

    public getResturl() {
        return window.config.REST_URL;
    }

    public getAmurl() {
        return window.config.AM_URL;
    }


    public getAemurl() {
        return window.config.AEM_URL;
    }


    public getAmClientId() {
        return window.config.AM_ClientId;
    }
    public getRedirecturi() {
        return window.config.redirect_uri;
    }
    public getScope() {
        return window.config.scope;
    }

    public getBasicAuth(){
        return window.config.basicAuth;
    }

   public getTokenEndPointsPKCE(){

     return window.config.pkce_token_endpoint;

   }

   public getTokenEndRevoke(){

    return window.config.pkce_token_revoke;

  }





  public getPlanName(){
    return window.config.planName;
  }
 

  public getSmartAppURL(){
    return window.config.smart_app_url;
  }
 
  public getEmailDL(){
    return window.config.emailDL;
  }

  public get_GettingStarted_Overview(){

   return window.config.GettingStarted_Overview;

  }
 
  public GettingStarted_CreateAnAccount(){

    return window.config.GettingStarted_CreateAnAccount;
 
  }
  public APIs_Subscription_Sandbox(){

    return window.config.APIs_Subscription_Sandbox;
 
  }
  public APIs_Subscription_Production(){

    return window.config.APIs_Subscription_Production;
 
  }

  public Creating_an_Application_ProdApp(){

    return window.config.Creating_an_Application_ProdApp;
 
  }

  public Creating_an_Application_SandboxApp(){

    return window.config.Creating_an_Application_SandboxApp;
 
  }


  public authentication_ehr_prod_apis(){

    return window.config.authentication_ehr_prod_apis;
 
  }

  public swaggerinfo(){

    return window.config.swaggerinfo;
 
  }

  public commonresponse(){

    return window.config.commonresponse;
 
  }

  public authentication_overview(){

    return window.config.authentication_overview;
 
  }

  public authentication_sandbox_apis(){

    return window.config.authentication_sandbox_apis;
 
  }

  public authentication_production_apis(){

    return window.config.authentication_production_apis;
 
  }
  public authentication_provider_directory_apis(){

    return window.config.authentication_provider_directory_apis;
 
  }

  public faq(){

    return window.config.faq;
 
  }

  public dev_report_url(){

    return window.config.dev_report_url;
 
  }

  public payer_report_url(){

    return window.config.payer_report_url;
 
  }

  public broker_report_url(){

    return window.config.broker_report_url;
 
  }

  public provider_report_url(){

    return window.config.provider_report_url;
 
  }






}